



































import { defineComponent, ref, watch } from '@vue/composition-api';

export default defineComponent({
  name: 'Nav',
  props: {
    menus: {
      type: Array,
      required: true,
    },
  },
  setup(props, { root }) {
    const activeIndex: any = ref('');

    const handleSelect = (key: any) => {
      if (key.indexOf('/') > -1) {
        activeIndex.value = '/';
      }
      activeIndex.value = key;
    };

    watch(() => root.$route.path, (val: any) => {
      activeIndex.value = val;
    }, {
      immediate: true,
    });
    return {
      activeIndex,
      handleSelect,
    };
  },
});
